export enum DatabaseSyncStatus {
  None,
  Pending,
  Complete,
  Failed,
  PartiallyComplete,
}
